export default {
  'sendpasswordsuccessfully.and': 'E',
  'sendpasswordsuccessfully.successfully': 'con successo',
  'sendpasswordsuccessfully.passwordsentto': 'Invia il collegamento per il recupero della password alle-mail ',
  'sendpasswordsuccessfully.sendpassword': 'password inviata correttamente',
  'sendpasswordsuccessfully.checkemail':
    "Per favore controlla l'e-mail per reimpostare la password",
};
